export default "__VITE_ASSET__BQmWI65p__"